import { BrandMark } from "./icons.jsx";

export default function SiteFooter() {
  return (
    <footer className="mt-24 bg-ocean-900 text-white/85">
      <div className="container-page py-16">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-5">
          <div className="col-span-2">
            <a href="/" className="inline-flex">
              <img src="https://home.aloharates.com/home_page/Untitled%20-%20December%2010%2C%202025%20at%2016.40.27%C2%A0(1).png" alt="Aloha Rates" className="h-10 w-auto"/>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/70">
              A Hawaiʻi-only guide to the best places to stay across all six islands. Real local rates, direct with the property, and stories from the people who actually live here.
            </p>
            <p className="mt-6 text-xs uppercase tracking-[0.14em] text-white/50">Stay in the loop</p>
            <form className="mt-3 flex max-w-sm items-center gap-2" onSubmit={e => e.preventDefault()}>
              <input type="email" required placeholder="you@example.com" className="min-w-0 flex-1 rounded-pill border border-white/15 bg-white/5 px-4 py-2.5 text-sm text-white placeholder:text-white/50 focus:border-white/40 focus:outline-none"/>
              <button className="btn-sunset px-5 py-2.5 text-sm">Sign up</button>
            </form>
          </div>
          <FooterCol title="Islands" links={[
            ["Oʻahu", "/oahu/"], ["Maui", "/maui/"], ["Kauaʻi", "/kauai/"],
            ["Hawaiʻi Island", "/big-island/"], ["Molokaʻi", "/molokai/"], ["Lānaʻi", "/lanai/"]
          ]}/>
          <FooterCol title="Stay style" links={[
            ["All stays", "/results/"], ["Condos", "/search/?type=condo"], ["Villas", "/search/?type=villa"],
            ["Resorts", "/search/?type=resort"], ["Beachfront", "/search/?amenity=beach"]
          ]}/>
          <FooterCol title="The Edit" links={[
            ["All guides", "/edit/"],
            ["When to visit", "/planning/best-time-to-visit-hawaii/"],
            ["Road to Hāna", "/experiences/maui-road-to-hana-guide/"],
            ["Family Hawaiʻi", "/families/family-friendly-hawaii/"]
          ]}/>
        </div>
        <div className="mt-12 border-t border-white/10 pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-white/60">
          <span>© 2026 Aloha Rates. All rights reserved.</span>
          <div className="flex gap-5">
            <a href="/list-your-property/" className="hover:text-white">List your property</a>
            <a href="/about/" className="hover:text-white">About</a>
            <a href="/contact/" className="hover:text-white">Contact</a>
            <a href="/privacy/" className="hover:text-white">Privacy</a>
            <a href="/terms/" className="hover:text-white">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <h4 className="font-sans text-xs uppercase tracking-[0.14em] text-white/60">{title}</h4>
      <ul className="mt-4 space-y-2 text-sm text-white/80">
        {links.map(([label, href]) => <li key={href}><a href={href} className="hover:text-white">{label}</a></li>)}
      </ul>
    </div>
  );
}
